import { StyleSheet, View } from "react-native";

import { ColorStyle } from "../../../constants/color";
import { PixelSize } from "../../../constants/pixelSize";
import { Spacing } from "../../../constants/spacing";
import { Text } from "../../../display/text";
import { AnchoredSheetDefinition } from "./anchoredSheet.definition/anchoredSheet.definition.types";
import { AnchoredSheetHeaderBackButton } from "./anchoredSheet.headerBackButton";

export const AnchoredSheetHeader: AnchoredSheetDefinition["Header"] = ({
  children,
  withBackBehavior,
  onClose,
}) => {
  return (
    <View style={styles.container}>
      {withBackBehavior && <AnchoredSheetHeaderBackButton onPress={onClose} />}
      <Text size="BODY" color="FONT_HIGH_EMPHASIS" weight="medium">
        {children}
      </Text>
    </View>
  );
};

const styles = StyleSheet.create({
  container: {
    flexDirection: "row",
    alignItems: "center",
    paddingHorizontal: Spacing.S16,
    height: PixelSize.S32,
    gap: Spacing.S8,
  },

  separator: {
    height: StyleSheet.hairlineWidth,
    flexGrow: 1,
    backgroundColor: ColorStyle.SEPARATOR,
  },
});
